import React from "react";
import "./ParentBottomNav.css";

const tabs = [
  { key: "children", label: "Діти" },
  { key: "tasks", label: "Завдання" },
  { key: "shop", label: "Магазин" },
  { key: "stats", label: "Статистика" },
];

function ParentBottomNav({ activeTab, setActiveTab }) {
  const handleLogout = () => {
    localStorage.removeItem("selectedUser");
    window.location.href = "/";
  };

  return (
    <nav className="parent-bottom-nav" aria-label="Навігація батьків">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={activeTab === tab.key ? "active" : ""}
          onClick={() => setActiveTab(tab.key)}
        >
          {tab.label}
        </button>
      ))}
      <button type="button" onClick={handleLogout}>
        Вийти
      </button>
    </nav>
  );
}

export default ParentBottomNav;
